import { render, staticRenderFns } from "./aiTagCom.vue?vue&type=template&id=0e82469c&scoped=true"
import script from "./aiTagCom.vue?vue&type=script&setup=true&lang=js"
export * from "./aiTagCom.vue?vue&type=script&setup=true&lang=js"
import style0 from "./aiTagCom.vue?vue&type=style&index=0&id=0e82469c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e82469c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/crm-admin-uat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e82469c')) {
      api.createRecord('0e82469c', component.options)
    } else {
      api.reload('0e82469c', component.options)
    }
    module.hot.accept("./aiTagCom.vue?vue&type=template&id=0e82469c&scoped=true", function () {
      api.rerender('0e82469c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CustomerDrawerCom/rightCom/aiTagCom.vue"
export default component.exports